import { computed, ComputedRef, Ref, ref } from 'vue';
import localforage from 'localforage';

localforage.config({
  driver: [localforage.INDEXEDDB, localforage.WEBSQL, localforage.LOCALSTORAGE],
  name: 'br.com.soluzion.teclado',
  version: '1.0',
});

export const clear = async () => localforage.clear();
export const writing = ref(0);
export const reading = ref(0);

export function useLocalforage<T>(
  key: string,
  def: T,
  defAfterRead: T | undefined = undefined
): [ComputedRef<T>, (newItem: T) => Promise<void>] {
  const item = ref<T>(def) as Ref<T>;
  reading.value = reading.value + 1;

  const getItem = computed(() => item.value);
  async function setItem(newItem: T) {
    writing.value = writing.value + 1;
    try {
      await localforage.setItem<T>(
        key,
        JSON.parse(JSON.stringify(newItem)) as T
      );
    } catch (err) {
      console.error(err);
    } finally {
      item.value = newItem;
      writing.value = writing.value - 1;
    }
  }

  void localforage
    .getItem<T>(key)
    .then(
      (storedItem) => {
        if (storedItem) item.value = storedItem;
        else if (defAfterRead !== undefined) item.value = defAfterRead;
      },
      (err) => {
        console.error(err);
      }
    )
    .finally(() => {
      reading.value = reading.value - 1;
    });

  return [getItem, setItem];
}
